import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { PlatformHero } from '../components/platform/PlatformHero';
import { PlatformIntro } from '../components/platform/PlatformIntro';
import { PlatformPhilosophy } from '../components/platform/PlatformPhilosophy';
import { PlatformStructure } from '../components/platform/PlatformStructure';
import { PlatformCapabilities } from '../components/platform/PlatformCapabilities';
import { PlatformHumanOpportunity } from '../components/platform/PlatformHumanOpportunity';
import { PlatformLifecycle } from '../components/platform/PlatformLifecycle';
import { PlatformApplications } from '../components/platform/PlatformApplications';
import { PlatformProducts } from '../components/platform/PlatformProducts';
import { PlatformInstitutional } from '../components/platform/PlatformInstitutional';
import { PlatformGlobal } from '../components/platform/PlatformGlobal';
import { PlatformClosing } from '../components/platform/PlatformClosing';
import { PlatformCTA } from '../components/platform/PlatformCTA';
export function PlatformPage() {
  return <div className="min-h-screen bg-surface-bg font-body text-ink-dark selection:bg-teal selection:text-white" data-id="element-598">
      <Navigation data-id="element-599" />
      <main data-id="element-600">
        <PlatformHero data-id="element-601" />
        <PlatformIntro data-id="element-602" />
        <PlatformPhilosophy data-id="element-603" />
        <PlatformStructure data-id="element-604" />
        <PlatformCapabilities data-id="element-605" />
        <PlatformHumanOpportunity data-id="element-606" />
        <PlatformLifecycle data-id="element-607" />
        <PlatformApplications data-id="element-608" />
        <PlatformProducts data-id="element-609" />
        <PlatformInstitutional data-id="element-610" />
        <PlatformGlobal data-id="element-611" />
        <PlatformClosing data-id="element-612" />
        <PlatformCTA data-id="element-613" />
      </main>
      <Footer data-id="element-614" />
    </div>;
}